import { EditProduct, Products, VariantDetails } from '../pages';

export const CatalogRoutes = [
  {
    path: '/product',
    exact: true,
    isPrivate: true,
    component: <Products />,
  },
  {
    path: '/product/details/:id',
    isPrivate: true,
    component: <EditProduct />,
  },
  {
    path: '/product/:id/variant/:variantid',
    isPrivate: true,
    component: <VariantDetails />,
  },
];
